import React from "react";
import { MAIN_APP_URL, trackCta } from "../../data/content";

const Footer = () => {
  return (
    <footer data-testid="footer" className="border-t border-white/10 bg-black">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-12">
        <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
          <div className="flex items-center gap-2.5">
            <span className="h-5 w-5 bg-white flex items-center justify-center">
              <span className="h-2 w-2 bg-black" />
            </span>
            <span className="font-display text-base font-semibold tracking-tight text-white">
              ROLL<span className="text-cyan-400">.</span>OPS
            </span>
            <span className="ml-2 px-2 py-0.5 text-[10px] font-mono uppercase tracking-[0.16em] text-zinc-500 border border-white/10">
              Tutorial site
            </span>
          </div>

          <nav className="flex flex-wrap items-center gap-x-7 gap-y-3 text-sm text-zinc-500">
            <a href="#overview" className="hover:text-white transition-colors" data-testid="footer-overview-link">Overview</a>
            <a href="#features" className="hover:text-white transition-colors" data-testid="footer-features-link">Features</a>
            <a href="#tutorial" className="hover:text-white transition-colors" data-testid="footer-tutorial-link">Tutorial</a>
            <a href="#faq" className="hover:text-white transition-colors" data-testid="footer-faq-link">FAQ</a>
            <a href="#contact" className="hover:text-white transition-colors" data-testid="footer-contact-link">Contact</a>
            <a
              href={MAIN_APP_URL}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackCta("footer-open-app-cta", "Open ROLL.OPS", "footer")}
              data-testid="footer-open-app-cta"
              className="text-cyan-400 hover:text-cyan-300 transition-colors font-medium"
            >
              Open ROLL.OPS →
            </a>
          </nav>
        </div>

        <div className="mt-10 pt-6 border-t border-white/5 flex flex-col sm:flex-row justify-between gap-3 font-mono text-xs text-zinc-600">
          <p>© {new Date().getFullYear()} ROLL.OPS — Covered Call Rolling Terminal.</p>
          <p>This is the onboarding & tutorial site, not the live app.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
